import React from 'react';
import {
  Banner,
  Button,
  Fade,
  Typography,
} from '@forgeglobal/design-framework';
import { useStyles } from './style';

interface PasswordSuccessBannerProps {
  message: string;
  dismissMessage: () => void;
}

const PasswordSuccessBanner = ({
  message,
  dismissMessage,
}: PasswordSuccessBannerProps) => {
  const classes = useStyles();

  return (
    <Fade
      in={!!message.length}
      timeout={750}
      style={{ display: message.length ? undefined : 'none' }}>
      <div>
        <Banner
          className={classes.success}
          action={
            <Button
              size="small"
              variant="text"
              onClick={dismissMessage}
              data-test-id="password-success-button">
              DISMISS
            </Button>
          }>
          <Typography
            variant="body2"
            color="textPrimary"
            data-test-id="login-message">
            {message}
          </Typography>
        </Banner>
      </div>
    </Fade>
  );
};

export default PasswordSuccessBanner;
